import { Project } from '@arra/core';
import { Box } from '@mui/material';
import { Logo, Text } from '../layout';
import { getProjectTitleWOYear } from '../../context/useProject';

export const Header = ({
  project,
  pageNumber,
}: {
  project: Project;
  pageNumber: number;
}) => {
  const projectName = getProjectTitleWOYear(project);
  return (
    <Box
      display="flex"
      alignItems="center"
      boxSizing="border-box"
      borderRight="1cm solid var(--PURPLE)"
      height="20mm"
      paddingRight={2}
      borderBottom="solid 2px var(--PURPLE)"
    >
      <Box flex={1} display="flex" alignItems="center" justifyContent="center">
        <Logo
          src="/SONAR LOGO COMPACT - Capsule blanche - 2025.png"
          maxWidth="120px"
          maxHeight="100px"
        />
      </Box>
      <Box
        borderLeft={1}
        height="45px"
        borderColor="var(--PURPLE)"
        marginLeft={2}
        marginRight={2}
      ></Box>
      <Text fontSize="22px" fontWeight="bold">
        {projectName}
      </Text>
      <Box
        borderLeft={1}
        height="45px"
        borderColor="var(--PURPLE)"
        marginLeft={2}
        marginRight={2}
      ></Box>
      <Text fontSize="22px" fontWeight="bold">
        {project.year}
      </Text>
      <Box
        borderLeft={1}
        height="45px"
        borderColor="var(--PURPLE)"
        marginLeft={2}
        marginRight={2}
      ></Box>
      <Box display="flex" width="100%" justifyContent="flex-end" columnGap={2}>
        <Text fontSize="20px" color="var(--¨PURPLE)" fontWeight="bold">
          RÉSULTATS
          <br />
          COMPLETS
        </Text>
        <Box borderLeft={1} height="45px" borderColor="var(--PURPLE)"></Box>
        <Text fontSize="40px" fontWeight="bold">
          {pageNumber.toString().padStart(2, '0')}
        </Text>
      </Box>
    </Box>
  );
};
